import { useRepo } from '../useStore.js';

function Column({ label, kind, notes, space, titlePlaceholder, bodyPlaceholder }) {
  const repo = useRepo();
  return (
    <div className="note-col">
      <div className="note-col-head">
        <div className="note-col-label">{label}</div>
        <button className="add-btn" onClick={() => repo.addNote(space.id, kind)}>+ Add</button>
      </div>
      {notes.map(n => (
        <div className="note" key={n.id}>
          <div className="note-head">
            <input
              className="note-title" aria-label={titlePlaceholder} placeholder={titlePlaceholder}
              value={n.title}
              onChange={e => repo.patchNote(n.id, { title: e.target.value })}
            />
            <button className="icon-x" aria-label="Delete note" onClick={() => repo.removeNote(n.id)}>×</button>
          </div>
          <textarea
            className="note-body" aria-label={bodyPlaceholder} placeholder={bodyPlaceholder}
            value={n.body}
            onChange={e => repo.patchNote(n.id, { body: e.target.value })}
          />
        </div>
      ))}
    </div>
  );
}

export default function Notes({ space }) {
  const notes = space ? space.notes : [];
  return (
    <div className="pane">
      <h2 className="pane-title">Characters &amp; World</h2>
      <p className="pane-sub">Reference notes for this space. They never leave your side while you write.</p>
      <div className="notes-grid">
        <Column
          label="Characters" kind="character" space={space}
          notes={notes.filter(n => n.kind === 'character')}
          titlePlaceholder="Name" bodyPlaceholder="Who are they? What do they want?"
        />
        <Column
          label="World & research" kind="world" space={space}
          notes={notes.filter(n => n.kind === 'world')}
          titlePlaceholder="Topic" bodyPlaceholder="Facts, places, sources…"
        />
      </div>
    </div>
  );
}
